import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyCgPE-h2tbSNmZo_bRQvO_HkkVkL-HTj30",
  authDomain: "poker-session-tracker-900ff.firebaseapp.com",
  databaseURL: "https://poker-session-tracker-900ff.firebaseio.com",
  projectId: "poker-session-tracker-900ff",
  storageBucket: "poker-session-tracker-900ff.firebasestorage.app",
  messagingSenderId: "349149004094",
  appId: "1:349149004094:web:c06ff56f23d725ad97ec6f"
};

const firebaseApp = initializeApp(firebaseConfig);
const db = getFirestore(firebaseApp);
const auth = getAuth(firebaseApp);
const storage = getStorage(firebaseApp);

export { firebaseApp, db, auth, storage };
